// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3LXNe","requiredAsterisk":"Info_requiredAsterisk__u2x2p"};